import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-expansion"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.7555 11.52V7.56622C14.7555 6.59659 13.9694 5.81055 12.9998 5.81055C12.0302 5.81055 11.2441 6.59659 11.2441 7.56622V16.3511L7.88164 15.6034C7.5274 15.5246 7.1612 15.6718 6.95999 15.9738L6.41602 16.7903L10.2778 21.8137C10.6103 22.2462 11.125 22.4997 11.6706 22.4997H18.7561C19.5123 22.4997 20.1837 22.0157 20.4228 21.2982L22.2052 15.9477C22.4679 15.1591 22.1419 14.2943 21.4241 13.8752L17.7994 11.7596C17.5306 11.6027 17.225 11.52 16.9138 11.52H14.7555Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.2441 16.3511V7.56622C11.2441 6.59659 12.0302 5.81055 12.9998 5.81055C13.9694 5.81055 14.7555 6.59659 14.7555 7.56622V11.52H16.9138C17.0767 11.52 17.2381 11.5427 17.3935 11.5868C17.5349 11.6269 17.6713 11.6848 17.7994 11.7596L21.4241 13.8752C22.1419 14.2943 22.4679 15.1591 22.2052 15.9477L20.4228 21.2982C20.1837 22.0157 19.5123 22.4997 18.7561 22.4997H11.6706C11.125 22.4997 10.6103 22.2462 10.2778 21.8137L6.41602 16.7903L6.95999 15.9738C7.1612 15.6718 7.5274 15.5246 7.88164 15.6034L11.2441 16.3511Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 1H10V4M3 5V8H6M9.39896 1.60105L3.7421 7.2579","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureExpansion = Vue.extend<IconProps>({
  name: 'GestureExpansionIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-expansion',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureExpansion;
